import { getPath } from '@/router/common'

const baseUrl = {
  title: '运力资源',
  path: 'TransportResources'
}

export default [
  {
    path: getPath('VehicleArchives', baseUrl),
    name: 'VehicleArchives',
    component: () => import(/* webpackChunkName: "VehicleArchives" */ '@/views/transportResources/vehicleArchives/index.vue'),
    meta: {
      title: '车辆档案'
    }
  },
  {
    path: getPath('VehicleData', baseUrl),
    name: 'VehicleData',
    component: () => import(/* webpackChunkName: "VehicleData" */ '@/views/transportResources/vehicleData/index.vue'),
    meta: {
      title: '车辆资料'
    }
  },
  //
  // {
  //   path: getPath('CustomerInformation', baseUrl),
  //   name: 'CustomerInformation',
  //   component: () => import(/* webpackChunkName: "CustomerArrangement" */ '@/views/transportResources/customerInformation/index.vue'),
  //   meta: {
  //     title: '司机档案'
  //   }
  // },
  {
    path: getPath('OperationExamination', baseUrl),
    name: 'OperationExamination',
    component: () => import(/* webpackChunkName: "OperationExamination" */ '@/views/transportResources/operationExamination/index.vue'),
    meta: {
      title: '运营考核'
    }
  },
  {
    path: getPath('OperationRecord', baseUrl),
    name: 'OperationRecord',
    component: () => import(/* webpackChunkName: "OperationRecord" */ '@/views/transportResources/operationRecord/index.vue'),
    meta: {
      title: '营运记录'
    }
  },
  // OperationRecord
  {
    path: getPath('Maintenance', baseUrl),
    name: 'MainTenance',
    component: () => import(/* webpackChunkName: "MainTenance" */ '@/views/transportResources/maintenance/index.vue'),
    meta: {
      title: '维修保养'
    }
  },
  {
    path: getPath('Carrier', baseUrl),
    name: 'TransportCarrier',
    component: () => import(/* webpackChunkName: "TransportCarrier" */ '@/views/transportResources/carrier/index.vue'),
    meta: {
      title: '承运单位'
    }
  },
  {
    path: getPath('AddDeliveryFeeStandard', baseUrl),
    name: 'AddDeliveryFeeStandard',
    component: () => import(/* webpackChunkName: "AddDeliveryFeeStandard" */ '@/views/transportResources/deliveryFeeStandard/addDeliveryFeeStandard.vue'),
    meta: {
      title: '运货费标准'
    }
  },

  // 97993定制
  {
    path: getPath('TruckDeliveryFeeStandard', baseUrl),
    name: 'TruckDeliveryFeeStandard',
    component: () => import(/* webpackChunkName: "TruckDeliveryFeeStandard" */ '@/views/transportResources/deliveryFeeStandard/truckDeliveryFeeStandard.vue'),
    meta: {
      title: '车型送货费标准'
    }
  },

  {
    path: getPath('DeliveryFeeStandard', baseUrl),
    name: 'DeliveryFeeStandard',
    component: () => import(/* webpackChunkName: "DeliveryFeeStandard" */ '@/views/transportResources/deliveryFeeStandard/index.vue'),
    meta: {
      title: '送货费标准'
    }
  },
  {
    path: getPath('MyGPSinfo', baseUrl),
    name: 'MyGPSinfo',
    component: () => import(/* webpackChunkName: "MyGPSinfo" */ '@/views/transportResources/myGPSinfo/index.vue'),
    meta: {
      title: 'GPS设备信息'
    }
  },
  {
    path: getPath('Vehiclesgz75313', baseUrl),
    name: 'VehiclesgZ75313',
    component: () => import(/* webpackChunkName: "Vehiclesgz75313" */ '@/views/transportResources/vehiclesgz75313/index.vue'),
    meta: {
      title: '司机工资'
    }
  },
  {
    path: getPath('Linesystem', baseUrl),
    name: 'LineSystem',
    component: () => import(/* webpackChunkName: "Linesystem" */ '@/views/transportResources/linesystem/index.vue'),
    meta: {
      title: '专线驻点运费体系'
    }
  },
  {
    path: getPath('CarMoneyGroup', baseUrl),
    name: 'CarMoneyGroup',
    component: () => import(/* webpackChunkName: "CarMoneyGroup" */ '@/views/transportResources/carMoneyGroup/index.vue'),
    meta: {
      title: '运营费用汇总'
    }
  },
  {
    path: getPath('RransNeed78961', baseUrl),
    name: 'RransNeed78961',
    component: () => import(/* webpackChunkName: "RransNeed78961" */ '@/views/transportResources/rransNeed78961/index.vue'),
    meta: {
      title: '碎石购销明细/司机运输/料厂/搅拌站'
    }
  },
  {
    path: getPath('RransNeedAddOrModify78961', baseUrl),
    name: 'RransNeedAddOrModify78961',
    component: () => import(/* webpackChunkName: "RransNeedAddOrModify78961" */ '@/views/transportResources/rransNeedAddOrModify78961/index.vue'),
    meta: {
      title: '新增编辑碎石购销明细/司机运输/料厂/搅拌站'
    }
  },
  {
    path: getPath('Lineprice75313', baseUrl),
    name: 'LinePrice75313',
    component: () => import(/* webpackChunkName: "Lineprice75313" */ '@/views/transportResources/lineprice75313/index.vue'),
    meta: {
      title: '线路合同价'
    }
  },
  {
    path: getPath('VehicleML75313', baseUrl),
    name: 'VehicleML75313',
    component: () => import(/* webpackChunkName: "VehicleML75313" */ '@/views/transportResources/vehicleML75313/index.vue'),
    meta: {
      title: '车辆毛利分析'
    }
  }
  // {
  //   path: getPath('ComplaintsAndSuggestions', baseUrl),
  //   name: 'ComplaintsAndSuggestions',
  //   component: () => import(/* webpackChunkName: "CustomerArrangement" */ '@/views/transportResources/complaintsAndSuggestions/index.vue'),
  //   meta: {
  //     title: '微步地图'
  //   }
  // }

]
